import React from 'react';
import { Breadcrumbs, BreadcrumbsItem } from '@itandi/itandi-bb-ui';
import { DefaultV2 } from '~/components/common/layouts/DefaultV2';
import { ClientSettingLayout } from '~/components/common/layouts/settings/ClientSettingLayout';
import SettingStyles from '../../../SettingStyle.module.scss';
import { PATH as STAFFS_PATH } from '~/pages/settings/staffs';
import { FormInputPage } from '../FormInputPage';

export const Page: React.FC = () => (
  <DefaultV2>
    <ClientSettingLayout>
      <div className={SettingStyles.BreadcrumbsBlock}>
        <Breadcrumbs>
          <BreadcrumbsItem href={STAFFS_PATH}>担当者一覧</BreadcrumbsItem>
          <BreadcrumbsItem isText>担当者追加</BreadcrumbsItem>
        </Breadcrumbs>
      </div>
      <h2 className={SettingStyles.SettingTitle}>担当者追加</h2>
      <FormInputPage />
    </ClientSettingLayout>
  </DefaultV2>
);
